import React from 'react'

function Social() {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/maka_chandan/" className="home__social-icon" target="_blank">
            <i className="uil uil-instagram"></i>
        </a>

        <a href="https://www.facebook.com/maka.chandan" className="home__social-icon" target="_blank">
        <i class="uil uil-facebook-f"></i>
        </a>

        <a href="https://www.linkedin.com/in/chandan-maka-8092b4225/" className="home__social-icon" target="_blank">
        <i class="uil uil-linkedin"></i>
        </a>

        <a href="https://github.com/chandanmaka" className="home__social-icon" target="_blank">
        <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social